import React from 'react';

import PropTypes from 'prop-types';

import { combineClasses } from 'wanderu-css';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './CompactDots.scss';

function CompactDots(props) {
    const {
        classes: classesProp = {},
    } = props;

    const classes = combineClasses(classesProp, styles);

    return (
        <svg className={classes.container} viewBox="0 0 140 50">
            <circle className={classes.circle} cx="20" cy="25" r="5"></circle>
            <circle className={classes.circle} cx="40" cy="25" r="5"></circle>
            <circle className={classes.circle} cx="60" cy="25" r="5"></circle>
            <circle className={classes.circle} cx="80" cy="25" r="5"></circle>
            <circle className={classes.circle} cx="100" cy="25" r="5"></circle>
        </svg>
    );
}

CompactDots.propTypes = {
    classes: PropTypes.object,
};

export default CompactDots;
